import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Visa = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 16 16">
    <path
      d="M15.6544 12.1907C15.6544 12.9422 15.0016 13.5515 14.1964 13.5515H1.80346C0.998277 13.5515 0.345459 12.9422 0.345459 12.1907V4.70632C0.345459 3.95482 0.998277 3.34552 1.80346 3.34552H14.1964C15.0016 3.34552 15.6544 3.95482 15.6544 4.70632V12.1907Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.80351 3.69103C1.16632 3.69103 0.69103 4.1677 0.69103 4.70631V12.1907C0.69103 12.7293 1.16632 13.206 1.80351 13.206H14.1965C14.8337 13.206 15.309 12.7293 15.309 12.1907V4.70631C15.309 4.1677 14.8337 3.69103 14.1965 3.69103H1.80351ZM0 4.70631C0 3.74192 0.83035 3 1.80351 3H14.1965C15.1697 3 16 3.74192 16 4.70631V12.1907C16 13.1551 15.1697 13.897 14.1965 13.897H1.80351C0.83035 13.897 0 13.1551 0 12.1907V4.70631Z"
      fill="#EEEEEE"
    />
    <path
      d="M5.18895 6.85383L4.35142 9.35175C4.35142 9.35175 4.13869 8.29511 4.11764 8.16243C3.64083 7.07454 2.93726 7.13514 2.93726 7.13514L3.76649 10.3621V10.3615H4.77465L6.16872 6.85383H5.18895ZM5.98725 10.3621H6.90292L7.45659 6.85383H6.52944L5.98725 10.3621ZM12.4677 6.85383H11.5042L10.002 10.3621H10.9116L11.0992 9.86109H12.2461L12.3437 10.3621H13.177L12.4677 6.85383ZM11.353 9.191L11.8515 7.86518L12.1124 9.191H11.353ZM8.75562 7.87635C8.75562 7.68307 8.91445 7.53923 9.36989 7.53923C9.66587 7.53923 10.0049 7.75419 10.0049 7.75419L10.1535 7.01777C10.1535 7.01777 9.72041 6.85352 9.29526 6.85352C8.33239 6.85352 7.83581 7.31406 7.83581 7.89708C7.83581 8.95148 9.10486 8.807 9.10486 9.34856C9.10486 9.44137 9.03118 9.65601 8.5027 9.65601C7.97263 9.65601 7.62276 9.46178 7.62276 9.46178L7.46488 10.1685C7.46488 10.1685 7.80391 10.3618 8.45901 10.3618C9.1157 10.3618 10.0266 9.87066 10.0266 9.16517C10.0266 8.31648 8.75562 8.25524 8.75562 7.87635Z"
      fill="#1565C0"
    />
    <path
      d="M4.24026 8.74991L3.93217 7.2356C3.93217 7.2356 3.7928 6.90741 3.43048 6.90741C3.06817 6.90741 2.0144 6.90741 2.0144 6.90741C2.0144 6.90741 3.81991 7.44067 4.24026 8.74991Z"
      fill="#FFC107"
    />
  </SvgIcon>
));

Visa.displayName = 'Visa';

export default Visa;
